/**
 * Heading anchor helpers shared by the Markdown preview (which stamps `id`s on
 * rendered headings) and the Peer Review Comments table-of-contents (which
 * links to them). Keeping the slug logic in one place guarantees the TOC link
 * and the rendered heading resolve to the same DOM id.
 */

/** Turn a heading's text into a stable, URL-safe anchor fragment. */
const slugifyHeading = (text: string): string =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

/**
 * Build the DOM id for a heading. The optional prefix namespaces the id by
 * section so identical sub-heading text in two different sections doesn't
 * collide (document.getElementById would otherwise always find the first one).
 */
export const buildHeadingId = (
  prefix: string | undefined,
  text: string,
): string => {
  const slug = slugifyHeading(text.trim());
  if (!slug) {
    return '';
  }
  return prefix ? `${prefix}-${slug}` : slug;
};
